import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ICardComponent } from '../../ICardComponent';
import { DomainCodes } from '../../../../models/const.DomainCodes';
import { CommonData } from '../../../_infrastructure/CommonData/CommonDataResolver';
import { ControlContainer, NgForm } from '@angular/forms';
import { AsyncDataService } from '../../../_infrastructure/AsyncData/AsyncDataService';
import { WorkflowComponent } from '../../workflow.component';
import { StepDetailsService } from '../../../_infrastructure/StepDetailsService/StepDetailsService';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'subscriber-contacts',
    templateUrl: './subscriber-contacts.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class SubscriberContactsComponent implements OnInit, OnDestroy, ICardComponent {
  public cardData: models.SubscriberContactsVM = {} as models.SubscriberContactsVM;
  public cardConfiguration: models.CardVM;

  @CommonData(DomainCodes.domains)
  public domains: models.DimensionVM[];
  @CommonData(DomainCodes.country)
  public countries: models.DimensionVM[];

  public parentWorkflow: WorkflowComponent;
  public certifiedData;
  public cgaSiteUser: boolean;
  public isExSubscritor: boolean;
  public mobilePlaceHolder: string;
  public landLinePlaceHolder: string;
  public mobilePattern: string;
  public landlinePattern: string;
  public parametersObject: phoneParameters;

  constructor(private http: HttpClient, private activeRoute: ActivatedRoute, private asyncDataService: AsyncDataService, private stepDetailsService: StepDetailsService) {
    this.parametersObject = new phoneParameters();
    this.stepDetailsService.workFlowCode.pipe(
      filter(el => el !== null && el !== undefined)
    )
    .subscribe(workflowCode => {
      this.isExSubscritor = (workflowCode.indexOf('PEDI008') == -1 && workflowCode.indexOf('PEDI005') == -1) ? false : true;
    });
  }

  ngOnInit(): void {
    if (this.isVersion2()) {
      if (this.parentWorkflow.workflowInstance.formData.StepCertification !== undefined) {
        this.certifiedData = this.parentWorkflow.workflowInstance.formData.StepCertification;
      }

      this.capitalizeCountries();
      //this.phonePlaceholder();

      this.mobilePattern = this.parametersObject.regexRuleMobile;
      this.landlinePattern = this.parametersObject.regexRuleLandLine;
    }

  }

  ngOnDestroy(): void {

  }

  ngDoCheck(): void {
    if (this.isVersion2()) {
      //Needs to be done in DoCheck because of step data being received asyncrously
      if (this.parentWorkflow.workflowInstance.formData.StepCertification !== undefined) {
        this.certifiedData = this.parentWorkflow.workflowInstance.formData.StepCertification;
      }
      if (this.cgaSiteUser === undefined) {
        this.cgaSiteUser = !!this.parentWorkflow.workflowInstance.formData?.StepSubscriberInfo?.['SubscriberContacts']?.['cgaSiteUser'] === true;
      }
    }
  }

  isVersion2() {
    let result = false;
    if (this.parentWorkflow.workflowInstance.formData['Version']?.toString() === '2') {
      result = true;
    }
    return result;
  }

  onPostalCodeChanged() {
    if (this.cardData.postalCodeFirst?.length == 4 && this.cardData.postalCodeLast?.length == 3) {
      try {
        this.asyncDataService.getPostalCodeDesignation(this.cardData.postalCodeFirst, this.cardData.postalCodeLast).subscribe(designation => {
          this.cardData.postalDesignation = designation;
        }, error => {
          console.log(error);
        });
      }
      catch (e) {
        console.log(e);
      }
    }
  }

  countryChanged() {
    if (this.parentWorkflow['currentStep']['currentStepData']['SubscriberPaymentInformation'] !== null &&
      this.parentWorkflow['currentStep']['currentStepData']['SubscriberPaymentInformation'] !== undefined) {
      this.parentWorkflow['currentStep']['currentStepData']['SubscriberPaymentInformation']['bankAccountTypeCode'] = undefined;
      this.parentWorkflow['currentStep']['currentStepData']['SubscriberPaymentInformation']['iban'] = undefined;
      this.parentWorkflow['currentStep']['currentStepData']['SubscriberPaymentInformation']['soleOwner'] = undefined;
      //this.phonePlaceholder();
    }

  }

  capitalizeCountries() {
    for (let i = 0; i < this.countries.length; i++) {
      this.countries[i].description = this.countries[i].description.toUpperCase();
    }
  }ele 

  capitalize(value: string) {
    this.cardData[value] = this.cardData[value].toUpperCase();
  }
  /*
  phonePlaceholder() {
    //this.landLinePlaceHolder = this.cardData.countryCode == 'PT' ? this.translate.instant("Placeholders.Generic.LandLineNumberMask") : this.translate.instant("Placeholders.Generic.LandLineNumberIntMask");
    //this.mobilePlaceHolder = this.cardData.countryCode == 'PT' ? this.translate.instant("Placeholders.Generic.MobileNumberMask") : this.translate.instant("Placeholders.Generic.MobileNumberIntMask");
    //this.mobilePattern = this.cardData.countryCode == 'PT' ? this.parametersObject.regexRuleMobile : this.parametersObject.regexRuleMobileInt;
    //this.landlinePattern = this.cardData.countryCode == 'PT' ? this.parametersObject.regexRuleLandLine : this.parametersObject.regexRuleLandLineInt;
  }
  */
}

class phoneParameters {
  //public regexRuleMobile: string = "^9\\d{8}$|^([+])(\\d{1,4})[\\\\ \\\\]\\d{1,12}$"; //"^9\\d{8}";
  public regexRuleMobile: string = "^9\\d{8}$|^(?!\\+351\\s)(([+])(\\d{1,4})[\\\\ \\\\]\\d{1,12})$";
  public regexRuleMobileInt: string = "^([+])(\\d{1,4})[\\\\ \\\\]\\d{1,}";
  //public regexRuleLandLine: string = "^(2|3)\\d{8}$|^([+])(\\d{1,4})[\\\\ \\\\]\\d{1,12}$"; //"^(2|3)\\d{8}";
  public regexRuleLandLine: string = "^(2|3)\\d{8}$|^(?!\\+351\\s)(([+])(\\d{1,4})[\\\\ \\\\]\\d{1,12})$";
  public regexRuleLandLineInt: string = "^([+])(\\d{1,4})[\\\\ \\\\]\\d{1,}";
}
